<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <el-row>
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <!-- 内容区 -->
        <div class="container">
          <!-- logo -->
          <div class="logo">
            <img v-if="bannerArr.length > 0" :src="$imgUrl+bannerArr[0].thumb" alt="" />
          </div>
          <div class="traffic_box">
            <div class="traffic_top_list">
              <div class="traffic_top_item">
                <div class="h2-title">{{langSet=='cn'?'从首都机场抵达展馆':'Arrive at the pavilion from Capital Airport'}}</div>
                <div class="traffic_icon1"></div>
                <div class="traffic_li">
                  <img src="../../assets/yd.jpg" alt="" />
                  <span
                    >{{langSet=='cn'?'驾   车：首都机场路- - -S12机场高速- - -天北路，车程6.4公里，用时约30分钟。':'By car: Capital Airport Road -- S12 Airport Expressway -- Tianbei Road, 6.4 km by car, takes about 30 minutes.'}}</span
                  >
                </div>
                <div class="traffic_li">
                  <img src="../../assets/yd_sel.jpg" alt="" />
                  <span>{{langSet=='cn'?'出租车：车费约30元，相距约6.4公里。':'Taxi: The fare is about 30 yuan and the distance is about 6.4 km.'}}</span>
                </div>
                <div class="traffic_li">
                  <img src="../../assets/yd.jpg" alt="" />
                  <span>{{langSet=='cn'?'地 铁：暂无合适的地铁线路。':'Subway: There is no suitable subway line.'}}</span>
                </div>
              </div>
              <div class="traffic_top_item">
                <div class="h2-title">{{langSet=='cn'?'从大兴机场抵达展馆':'Arrive at the pavilion from Daxing Airport'}}</div>
                <div class="traffic_icon1"></div>
                <div class="traffic_li">
                  <img src="../../assets/yd.jpg" alt="" />
                  <span
                    >{{langSet=='cn'?'驾   车：S3501大兴机场高速- - -六环- - -S32京平高速- - -京密路- - -天北路，相距约80公里，用时约2小时。':'By car: S3501 Daxing Airport Expressway -- Sixth Ring Road -- S32 Jingping Expressway -- Jingmi Road -- Tianbei Road, about 80 kilometers away, takes about 2 hours.'}}</span
                  >
                </div>
                <div class="traffic_li">
                  <img src="../../assets/yd.jpg" alt="" />
                  <span>{{langSet=='cn'?'出租车：车费约270元。':'Taxi: The fare is about 270 yuan.'}}</span>
                </div>
                <div class="traffic_li">
                  <img src="../../assets/yd_sel.jpg" alt="" />
                  <span>{{langSet=='cn'?'地铁：大兴机场线至草桥站（10号线）去往惠新西街南口站，换乘5号去往大屯路东站，换乘15号线抵达国战新馆站。':'By subway: Daxing Airport Line to Caoqiao Station (Line 10) to Huixin West Street South exit station, transfer to Line 5 to Datun Road East Station, transfer to Line 15 to Guozhanxinguan Station.'}}</span
                  >
                </div>
              </div>
            </div>
            <div class="traffic_line"></div>
            <div class="traffic_top_list">
              <div class="traffic_top_item">
                <div class="h2-title">{{langSet=='cn'?'从北京站抵达展馆':'Arrive at the pavilion from Beijing Station'}}</div>
                <div class="traffic_icon2"></div>
                <div class="traffic_li">
                  <img src="../../assets/yd.jpg" alt="" />
                  <span>{{langSet=='cn'?'驾 车：二环- - -S12机场高速- - -京密路，相距25公里，用时约1小时':'By car: Second Ring Road -- S12 Airport Expressway -- Jingmi Road, 25 kilometers away, takes about 1 hour'}}</span
                  >
                </div>
                <div class="traffic_li">
                  <img src="../../assets/yd.jpg" alt="" />
                  <span>{{langSet=='cn'?'出租车：车费约100元。':'Taxi: The fare is about 100 yuan.'}}</span>
                </div>
                <div class="traffic_li">
                  <img src="../../assets/yd_sel.jpg" alt="" />
                  <span>{{langSet=='cn'?'地 铁：乘坐地铁2号线去往东直门站，换乘13号线到达望京西，再换乘15号线抵达国展新馆站。':'Subway: Take Metro Line 2 to Dongzhimen Station, transfer to Line 13 to Wangjing West, then transfer to Line 15 to Guozhan Xinguan Station.'}}</span
                  >
                </div>
              </div>
              <div class="traffic_top_item">
                <div class="h2-title">{{langSet=='cn'?'从北京南站抵达展馆':'Arrive at the pavilion from Beijing South Railway Station'}}</div>
                <div class="traffic_icon2"></div>
                <div class="traffic_li">
                  <img src="../../assets/yd.jpg" alt="" />
                  <span>{{langSet=='cn'?'驾 车：二环- - -四环- - -S12机场高速，相距约36公里，用时约1小时20分钟。':'Driving: The second Ring Road -- the Fourth Ring Road -- S12 airport highway, about 36 kilometers away, takes about 1 hour and 20 minutes.'}}</span
                  >
                </div>
                <div class="traffic_li">
                  <img src="../../assets/yd.jpg" alt="" />
                  <span>{{langSet=='cn'?'出租车：车费约130元。':'Taxi: The fare is about 130 yuan.'}}</span>
                </div>
                <div class="traffic_li">
                  <img src="../../assets/yd_sel.jpg" alt="" />
                  <span>{{langSet=='cn'?'地 铁：乘坐地铁14号线抵达望京站，换乘15号线抵达国展新馆站。':'Subway: Take Metro Line 14 to Wangjing Station, then transfer to Line 15 to Guozhan Xinguan Station.'}}</span
                  >
                </div>
              </div>
              <div class="traffic_top_item">
                <div class="h2-title">{{langSet=='cn'?'从北京西站抵达展馆':'Arrive at the pavilion from Beijing West Railway Station'}}</div>
                <div class="traffic_icon2"></div>
                <div class="traffic_li">
                  <img src="../../assets/yd.jpg" alt="" />
                  <span>{{langSet=='cn'?'驾 车：二环- - -S12机场高速- - -京密路，相距37公里，用时约1小时20分钟。':'By car: The Second Ring Road -- S12 airport Expressway -- Jingmi Road, 37 kilometers away, takes about 1 hour and 20 minutes.'}}</span
                  >
                </div>
                <div class="traffic_li">
                  <img src="../../assets/yd.jpg" alt="" />
                  <span>{{langSet=='cn'?'出租车：车费约140元。':'Taxi: The fare is about 140 yuan.'}}</span>
                </div>
                <div class="traffic_li">
                  <img src="../../assets/yd_sel.jpg" alt="" />
                  <span>{{langSet=='cn'?'地 铁：乘坐地铁7号线抵达九龙山站，换乘14号线抵达望京站，换乘15号线抵达国展新馆站。':'Subway: Take Subway Line 7 to Kowloon Hill Station, transfer to Line 14 to Wangjing Station, transfer to Line 15 to Guozhan Xinguan Station.'}}</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>

<script>
import top from "../../components/top.vue";
import bottom from "../../components/bottom.vue";
import { getBanner } from "@/api/api";
export default {
  components: { top, bottom },
  name: "home",
  // 配置title和meta数据
  metaInfo() {
    return {
      title:this.langSet=='cn'?this.keydata.name_cn:this.keydata.name_en,
      meta: [
        {
          name: "description",
          content: this.keydata.description,
        },
        {
          name: "keywords",
          content: this.keydata.keywords,
        },
      ],
    };
  },
  data() {
    return {
      langSet: "",
      bannerArr: [],
      keydata:{}
    };
  },
  activated(){
    let menuArr=JSON.parse(localStorage.getItem('menuArr'))
    console.log(menuArr,"menuArr")
     menuArr.map(item=>{
      if(item.children){
        item.children.map(i=>{
            if(i.name_cn=='交通'||i.name_en=='Traffic'){
                this.keydata=i;
          }
        })
      }
       
     })
  },
  created() {},
  mounted() {
    this.langSet = localStorage.getItem("languageSet") || "cn";
    this.getBannerList();
  },
  methods: {
    // zhang 获取展会服务banner
    getBannerList() {
      let data = {
        class: "展会交通",
        lang_type: this.langSet,
      };
      getBanner(data)
        .then((res) => {
          if (res.code == 1) {
            this.bannerArr = res.data.lists;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  // width: 1280px;
  margin: 0 auto;
  padding: 80px 0;
  box-sizing: border-box;
  .logo {
    width: 100%;
    height: auto;
    img {
      width: 100%;
      height: auto;
    }
  }
  .traffic_box {
    margin-top: 80px;
    .traffic_line {
      width: 100%;
      border: 1px dashed #243889;
      margin: 30px 0 80px;
    }
    .traffic_top_list {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .traffic_top_item {
        margin-bottom: 50px;
        .traffic_icon1 {
          width: 200px;
          height: 58px;
          background: url("../../assets/fj.jpg");
          background-size: 100% 100%;
          margin: 10px 0 30px;
        }
        .traffic_icon2 {
          width: 200px;
          height: 58px;
          background: url("../../assets/gt.jpg");
          background-size: 100% 100%;
          margin: 10px 0 30px;
        }
        .traffic_li {
          display: flex;
          align-items: center;
          margin-bottom: 20px;
          img {
            width: 20px;
            height: 20px;
          }
          span {
            display: inline-block;
            width: 580px;
            line-height: 22px;
            margin-left: 10px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 16px;
            color: #2c2c2e;
          }
        }
      }
    }
  }
}
@media only screen and (max-width: 767px) {
  .container {
    width: 100% !important;
    padding: 0 !important;
    background: rgba(171, 181, 205, 0.1) !important;
    .logo {
      width: 100%;
      height: auto !important;
      img {
        width: 100%;
        height: auto !important;
      }
    }
    .traffic_box {
      margin-top: 51px !important;

      padding: 0 20px 50px !important;
      .h2-title {
        font-size: 18px !important;
        font-weight: 500 !important;
      }
      .traffic_icon1 {
        width: 100px !important;
        height: 29px !important;
        margin: 5px 0 11px !important;
      }
      .traffic_icon2 {
        width: 100px !important;
        height: 29px !important;
        margin: 5px 0 11px !important;
      }
      .traffic_line {
        margin: 0 0 50px !important;
      }
      .traffic_top_list {
        .traffic_top_item {
          .traffic_li {
            img {
              width: 14px !important;
              height: 14px !important;
            }
            span {
              font-size: 14px !important;
              width: 100% !important;
              line-height: 22px !important;
            }
          }
        }
      }
    }
  }
}
</style>